import script from "./ProductPickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPickerModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductPickerModal.vue?vue&type=style&index=0&id=5ff9e3d6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff9e3d6"]])

export default __exports__